"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HandlerAsync {
    constructor(closure, onError) {
        return closure().catch((exception) => {
            onError && onError(exception);
            throw exception;
        });
    }
}
exports.default = HandlerAsync;
